import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Path } from 'config/portal'
import { selectors } from '../reducer'
import { selectors as globalSelectors } from '../../reducer'
import { selectors as apiSelectors } from 'lp-redux-api'
import { selectors as productSelectors } from '../../products/reducer'
import * as apiActions from 'api-actions'
import * as productsActions from '../../products/actions'
import { flashSuccessMessage, flashErrorMessage } from 'redux-flash'
import SharedCompletePlanAgreementView from '../../products/views/CompletePlanAgreementView'

function CompletePlanAgreementView(props) {
  return (
    <SharedCompletePlanAgreementView
      {...props}
      emptyFormRedirectPath={Path.ADD_NEW_SERVICES_AGREEMENT}
      successRedirectPath={Path.SERVICES_AGREEMENTS}
    />
  )
}

function mapStateToProps(state) {
  return {
    transformedPlanSponsors: selectors.transformedPlanSponsors(state),
    transformedRecordkeepers: selectors.transformedRecordkeepers(state),
    transformedTpas: selectors.transformedTpas(state),
    transformedConsultants: selectors.transformedConsultants(state),
    availableInitialInvestments:
      productSelectors.availableInitialInvestments(state),
    completeServicesAgreementForm:
      selectors.completeServicesAgreementForm(state),
    currentUser: globalSelectors.currentUser(state),
    isSubmittingServicesAgreementForm: apiSelectors.isLoading(
      state,
      apiActions.submitServicesAgreementForm
    ),
    addAddendum: selectors.addAddendum(state),
    addNotificationsAddendum: selectors.addNotificationsAddendum(state),
  }
}

const mapDispatchToProps = {
  flashSuccessMessageHandler: flashSuccessMessage,
  flashErrorMessageHandler: flashErrorMessage,
  fetchAvailableInitialInvestments: apiActions.fetchAvailableInitialInvestments,
  fetchPlanSponsors: apiActions.fetchPlanSponsors,
  fetchRecordkeepers: apiActions.fetchRecordkeepers,
  fetchTpas: apiActions.fetchTpas,
  fetchConsultants: apiActions.fetchConsultants,
  submitServicesAgreementForm: apiActions.submitServicesAgreementForm,
  setShouldTriggerAllServicesAgreementsFetch:
    productsActions.setShouldTriggerAllServicesAgreementsFetch,
  setShouldTriggerAllBDPlanAgreementsFetch:
    productsActions.setShouldTriggerAllBDPlanAgreementsFetch,
  setShouldTriggerAllNotificationsPlanAgreementsFetch:
    productsActions.setShouldTriggerAllNotificationsPlanAgreementsFetch,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CompletePlanAgreementView
)
